import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Configuration } from "./configuration.model";
import { ConfigurationService } from "./configuration.service";


@Component({
    selector: 'app-configuration',
    templateUrl: './configuration.component.html',
    styleUrls: ['./configuration.component.css']
})
export class ConfigurationComponent implements OnInit {
    public configForm: FormGroup;
    public configurations: Configuration[] = [];
    public totalUnderwriterCapacity: number = 0;

    constructor(
        public dialogRef: MatDialogRef<ConfigurationComponent>,
        private fb: FormBuilder,
        private configService: ConfigurationService) {
    }

    ngOnInit() {
        this.getConfigs();
        this.getCapacities();
    }

    createForm() {
        this.configForm = this.fb.group({
            underwriterCapacity: [this.configurations[0].value, Validators.required],
            totalUnderwriterCapacity: [this.totalUnderwriterCapacity, null]
        });
    }

    onSubmit() {

        if (!this.configForm.valid)
            return;

        this.prepareSaveConfigs();
        this.configService.updateConfigurations(this.configurations)
            .then(resp => {
                this.configurations = resp;
                this.dialogRef.close();
            }).catch(err => {
                confirm(
                    "There was an error updating this config, please try again. If this problem persists, please contact IT support.");
            });
    }

    prepareSaveConfigs() {
        this.configurations[0].value = this.configForm.value.underwriterCapacity;
    }

    getConfigs() {

        this.configService.getConfigurations()
            .then(resp => {
                this.configurations = resp;
                this.createForm();
            }).catch(err => {
                confirm(
                    "There was an error retrieving configurations, please try again. If this problem persists, please contact IT support.");
                this.dialogRef.close();
            });
    }

    getCapacities() {
        this.configService.getTotalUnderwriterCapacity()
            .then(resp => {
                this.totalUnderwriterCapacity = resp;
                this.createForm();
            }).catch(err => {
                confirm(
                    "There was an error retrieving total underwriter capacity, please try again. If this problem persists, please contact IT support.");
                this.dialogRef.close();
            });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/configuration/configuration.component.ts